import { styled } from '@mui/material';

export const Header = styled('span')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '38px',
  lineHeight: '44px',
  letterSpacing: '-0.02em',
  marginBottom: theme.spacing(1),
  textAlign: 'center',

  [theme.breakpoints.down('md')]: {
    fontSize: '24px',
    lineHeight: '32px',
  },
}));

export const SubHeader = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '18px',
  lineHeight: '24px',
  letterSpacing: '-0.02em',
  marginBottom: theme.spacing(8),
  textAlign: 'center',
}));

export const Logo = styled('div')(({ theme }) => ({
  fontWeight: 600,
  fontSize: '22px',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(5),
  marginBottom: theme.spacing(2),
}));

export const FormLabel = styled('span')(({ theme }) => ({
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '20px',
  color: theme.palette.text.secondary,
}));
